<template>
  <v-row>
    <v-col cols="12" md="9">
      <BaseBlock title="La protection des données personnelles à l'université">
        <h2 class="subtitle-1 font-weight-bold">
          Le délégué à la protection des données au cœur du nouveau règlement
          européen
        </h2>
        <p>
          Depuis le 25 mai 2018, dans toute l’Europe, un nouveau cadre juridique
          est applicable concernant la protection des données. Au sein de
          l'université, le délégué à la protection des données est chargé
          d’accompagner les étudiants et les personnels de l’Université de Lille
          à se conformer aux obligations prévues non seulement par la Loi
          informatique et libertés mais également par le RGPD. Il a l’obligation
          de tenir un registre de l’ensemble des traitements mis en œuvre et
          disponibles sur
          <a href="https://wikis.univ-lille.fr/cil/">le site du CIL</a>.
          <br />En tant que chef d’orchestre de la conformité en matière de
          protection des données personnelles, il est précisément en charge :
        </p>
        <ul>
          <li>
            d’informer, de conseiller et de sensibiliser le responsable de
            traitement ainsi que l’ensemble des personnels et étudiants ;
          </li>
          <li>
            de contrôler le respect du règlement et du droit national en matière
            de protection des données ;
          </li>
          <li>
            de conseiller l’organisme sur la réalisation d’une analyse d'impact
            relative à la protection des données et d’en vérifier l’exécution ;
          </li>
          <li>
            de coopérer avec l’autorité de contrôle et d’être le point de
            contact de celle-ci.
          </li>
        </ul>
      </BaseBlock>
    </v-col>

    <v-col cols="12" md="3">
      <BaseBlock title="Sidebar">
        <ul>
          <li>l’ensemble des personnels et étudiants ;</li>
          <li>protection des données ;</li>
          <li>vérifier l’exécution ;</li>
          <li>être le point de contact de celle-ci.</li>
        </ul>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "About",
  components: { BaseBlock },
};
</script>
